import React from 'react';

import CreditAcceptanceRate from './CreditAcceptanceRate';
import WLIcon from './WLIcon';

const CreditDataTableMobile = ({ items, wls, className }) => {
  const renderCreditInstoreDataRow = (item, index, stripe, wl, wlRowspan) => {
    return (
      <tr key={'cdtam' + index} className={stripe}>
        <td rowSpan={wlRowspan}>
          <WLIcon item={wl} index={index} />
        </td>
        <td>Store</td>
        <td>{item.instore.TODAY.totalCustomers}</td>
        <td>{item.instore.TODAY.refused}</td>
        <td>{item.instore.TODAY.approved}</td>

        <td>
          <CreditAcceptanceRate
            key={'todayInNet' + index}
            rate={item.instore.TODAY.netAcceptanceRate}
            colourCode={item.instore.TODAY.colour}
          />
        </td>
        <td>{item.instore.LAST7DAYS.totalCustomers}</td>
        <td>{item.instore.LAST7DAYS.refused}</td>
        <td>{item.instore.LAST7DAYS.approved}</td>

        <td>
          <CreditAcceptanceRate
            key={'l7InNet' + index}
            rate={item.instore.LAST7DAYS.netAcceptanceRate}
            colourCode={item.instore.LAST7DAYS.colour}
          />
        </td>

        <td>{item.instore.LAST28DAYS.totalCustomers}</td>
        <td>{item.instore.LAST28DAYS.refused}</td>
        <td>{item.instore.LAST28DAYS.approved}</td>

        <td>
          <CreditAcceptanceRate
            key={'l28InNet' + index}
            rate={item.instore.LAST28DAYS.netAcceptanceRate}
            colourCode={item.instore.LAST28DAYS.colour}
          />
        </td>
      </tr>
    );
  };
  const renderCreditOnlineDataRow = (item, index, stripe, wl) => {
    return (
      <tr key={'cdtbm' + index} className={stripe}>
        <td>Online</td>
        <td>{item.online.TODAY.totalCustomers}</td>
        <td>{item.online.TODAY.refused}</td>
        <td>{item.online.TODAY.approved}</td>

        <td>
          <CreditAcceptanceRate
            key={'todayOnNet' + index}
            rate={item.online.TODAY.netAcceptanceRate}
            colourCode={item.online.TODAY.colour}
          />
        </td>

        <td>{item.online.LAST7DAYS.totalCustomers}</td>
        <td>{item.online.LAST7DAYS.refused}</td>
        <td>{item.online.LAST7DAYS.approved}</td>

        <td>
          <CreditAcceptanceRate
            key={'l7OnNet' + index}
            rate={item.online.LAST7DAYS.netAcceptanceRate}
            colourCode={item.online.LAST7DAYS.colour}
          />
        </td>

        <td>{item.online.LAST28DAYS.totalCustomers}</td>
        <td>{item.online.LAST28DAYS.refused}</td>
        <td>{item.online.LAST28DAYS.approved}</td>

        <td>
          <CreditAcceptanceRate
            key={'l28OnNet' + index}
            rate={item.online.LAST28DAYS.netAcceptanceRate}
            colourCode={item.online.LAST28DAYS.colour}
          />
        </td>
      </tr>
    );
  };

  return (
    <table className={`StatsTable narrowTable ${className}`}>
      <colgroup>
        <col width='6%' />
        <col width='12%' />
        <col width='6%' />
        <col width='6%' />
        <col width='6%' />
        <col width='10%' />
        <col width='6%' />
        <col width='6%' />
        <col width='6%' />
        <col width='10%' />
        <col width='6%' />
        <col width='6%' />
        <col width='6%' />
        <col width='10%' />
      </colgroup>
      <tbody>
        <tr>
          <th colSpan='14'>
            <span className='StatsTable_caption'>Credit Data</span>
          </th>
        </tr>

        <tr className='StatsTable_innerHeaderLarge'>
          <td rowSpan='2' />
          <td rowSpan='2'>Channel</td>
          <td colSpan='4' className='narrowTable'>
            Today
          </td>
          <td colSpan='4' className='narrowTable'>
            Last 7 Days
          </td>
          <td colSpan='4' className='narrowTable'>
            Last 28 Days
          </td>
        </tr>
        <tr className='StatsTable_innerHeader'>
          <td className='StatsTable_rotate'>
            <div>Customers</div>
          </td>
          <td className='StatsTable_rotate'>
            <div>Refused</div>
          </td>
          <td className='StatsTable_rotate'>
            <div>Approved</div>
          </td>

          <td className='StatsTable_rotate'>
            <div>Net Acc Rate %</div>
          </td>
          <td className='StatsTable_rotate'>
            <div>Customers</div>
          </td>
          <td className='StatsTable_rotate'>
            <div>Refused</div>
          </td>
          <td className='StatsTable_rotate'>
            <div>Approved</div>
          </td>

          <td className='StatsTable_rotate'>
            <div>Net Acc Rate %</div>
          </td>
          <td className='StatsTable_rotate'>
            <div>Customers</div>
          </td>
          <td className='StatsTable_rotate'>
            <div>Refused</div>
          </td>
          <td className='StatsTable_rotate'>
            <div>Approved</div>
          </td>
          <td className='StatsTable_rotate'>
            <div>Net Acc Rate %</div>
          </td>
        </tr>

        {items.map((item, index) => {
          var wl = wls.find(function (element) {
            return element.wlID === item.wlID;
          }, item.wlID);
          var stripe = index % 2 === 1 ? 'stripe_even' : 'stripe_odd';
          var wlRowspan = 1;
          if (item.online.TODAY) wlRowspan = 2;
          var rows = [];
          if (item.instore.TODAY)
            rows.push(
              renderCreditInstoreDataRow(item, index, stripe, wl, wlRowspan),
            );
          if (item.online.TODAY)
            rows.push(renderCreditOnlineDataRow(item, index, stripe, wl));
          return rows;
        })}

        {items.length === 0 && (
          <tr>
            <td colSpan='26' className='StatsTable_none'>
              No Credit Data
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default CreditDataTableMobile;
